module.exports = __webpack_public_path__ + "static/benefits-img2-52d8d3e01a280872f46d5ab5c312b72d.png";